import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

const PRELOAD_PATHS = new Set(['entreprises', 'offres']);

@Injectable({ providedIn: 'root' })
export class EntreprisesOffresPreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    const path = route.path ?? '';
    if (!PRELOAD_PATHS.has(path)) {
      return of(null);
    }
    return timer(1500).pipe(mergeMap(() => load()));
  }
}
